<template>

    <div v-if="dataStore.showConfirmation" id="confirmation-view" v-on:click="hide($event)" class="confirmation-view">

        <div>

            <span title="Close" v-if="isAllowed" class="close-popup a" @click="toggleConfirmation()"><i class="fas fa-times"></i></span>

            <a title="Close" v-if="!isAllowed" :href="newUrl + '?hide_welcome=true'" class="close-popup b"><i class="fas fa-times"></i></a>

            <div class="container">

                <div class="row">

                    <div class="col-12">

                        <h3 v-html="project.thank_you_title"></h3>

                        <p v-html="project.thank_you"></p>

                        <div class="buttons">

                            <a :title="language.view_comments" :href="newUrl + typeUrl + dataStore.deepLink" class="link-to-share btn btn-secondary">{{ language.view_comments }}</a>

                            <button :title="language.share" v-if="project.hide_share" @click="copyText()" class="btn btn-primary" id="share">{{ language.share }}</button>

                        </div>

                        <p id="copy-text" v-if="copytext">{{copytext}}</p>

                    </div>

                </div>

            </div>

        </div>

    </div>

</template>

<script>

import dataStore from "../../store";

import { goToFirst } from './../../functions'

export default {

    inject: [ 'language' ],

    data() {
        return {
            dataStore: dataStore,
            copytext : '',
            isAllowed : true
        };
    },

    computed: {

        typeUrl : function() {

            const language = {
                en : '/comment/',
                sv : '/synpunkt/',
                fr : '/comment/',
                de : '/comment/',
            }

            return language[this.project.language.code]
        },

        newUrl: function() {

            if(this.geturl.includes(this.typeUrl)) {
                const urlParts = this.geturl.split(this.typeUrl)
                return urlParts[0];
            }

            return this.geturl
        }
    },

    props: {
        project: Object,
        geturl: String,
        addurl: String,
    },

    mounted() {
        if(window.location.href === this.geturl ) {
            this.isAllowed = false
        }
    },

    methods: {

        hide: function(e){
            if( e.srcElement.className.includes('confirmation-view') ){
                this.dataStore.showConfirmation = false;
                this.dataStore.formPopUpReady = true;
            }
        },

        toggleConfirmation : function() {
            goToFirst();
            this.dataStore.showConfirmation = false;
            this.dataStore.addToExistingWindow = false
            this.dataStore.formPopUpReady = false
        },

        copyText: function() {
            const el = document.querySelector('.link-to-share');
            const url = el.getAttribute("href");
            this.copyStringToClipboard(url);
        },

        copyStringToClipboard: function (str) {

            try {
                // Create new element
                var el = document.createElement('textarea');
                // Set value (string to be copied)
                el.value = str;
                // Set non-editable to avoid focus and move outside of view
                el.setAttribute('readonly', '');
                el.style = {position: 'absolute', left: '-9999px'};
                document.body.appendChild(el);
                // Select text inside element
                el.select();
                // Copy text to clipboard
                document.execCommand('copy');
                // Remove temporary element
                document.body.removeChild(el);

                this.copytext = this.language.link_copied;

            } catch (error) {
                this.copytext = this.language.something_went_wrong;
            }

            setTimeout(() => { this.copytext = '' }, 3000);

        }

    }

};
</script>

